import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import { SidebarContent } from './SidebarContent';

const sidebarNavContent = NavContentBlueprint.make({
  params: { component: SidebarContent },
});

export const sidebarNavModule = createFrontendModule({
  pluginId: 'app',
  extensions: [sidebarNavContent],
});
